import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "col-lg-5 col-sm-6 text-right" }
const _hoisted_9 = { class: "dropdown" }
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "container"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "fg-color-red1" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 6,
  class: "form-group"
}
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "form-check form-check-inline" }
const _hoisted_31 = ["id", "value"]
const _hoisted_32 = ["for"]
const _hoisted_33 = {
  key: 0,
  class: "form-group"
}
const _hoisted_34 = { class: "form-check form-check-inline" }
const _hoisted_35 = {
  class: "form-check-label",
  for: "clearDatasetOnRun"
}
const _hoisted_36 = {
  key: 1,
  class: "form-group"
}
const _hoisted_37 = { class: "form-check form-check-inline" }
const _hoisted_38 = { class: "form-check form-check-inline" }
const _hoisted_39 = { class: "form-check form-check-inline" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = { class: "form-check form-check-inline" }
const _hoisted_42 = { class: "form-check form-check-inline" }
const _hoisted_43 = { class: "form-check form-check-inline" }
const _hoisted_44 = { class: "form-check form-check-inline" }
const _hoisted_45 = { class: "form-check form-check-inline" }
const _hoisted_46 = { class: "form-check form-check-inline" }
const _hoisted_47 = { class: "form-check form-check-inline" }
const _hoisted_48 = {
  key: 2,
  class: "form-group"
}
const _hoisted_49 = ["value"]
const _hoisted_50 = {
  key: 3,
  class: "form-group"
}
const _hoisted_51 = ["value"]
const _hoisted_52 = ["href"]
const _hoisted_53 = {
  key: 7,
  class: "container"
}

import { computed, ref, watch, onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminPipelineDetailsPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminPipelineDetailsPage',
  setup(__props) {

    const router = useRouter()
    const tid = useOrganizationUnitId()
    const id = useId()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useAllPipelinesQuery,
        useActivatePipelineCommand,
        useDeactivatePipelineCommand,
        useTriggerPipelineManuallyCommand,
        useChangePipelineTimeTriggerRecurrencyCommand,
        useChangePipelineTriggerOnRunCompletedCommand,
        useChangePipelineInternalConnectorTriggerCommandV1,
        useChangeApplyChangesModeCommand,
        useChangeClearDatasetOnRunCommand,
        useSetPipelineLogLevelCommand,
        useResetPipelineRunsCommand,
        useDeletePipelineCommand,
        usePermanentDeletePipelineCommand,
    } = useAdminPipelineDetailsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelAllPipelinesQueryV1, runAllPipelinesQueryV1 } = useAllPipelinesQuery(tid)
    const pipelines = computed(() => modelAllPipelinesQueryV1.value?.Pipelines || [])
    const otherPipelines = computed(() => pipelines.value.filter(p => p.PipelineId != id))

    const { modelPipelineDetailsQueryV1, runPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const name = computed(() => modelPipelineDetailsQueryV1.value?.Name)
    const isReadDirection = computed(() => modelPipelineDetailsQueryV1.value?.Direction === 1)
    const isWriteDirection = computed(() => modelPipelineDetailsQueryV1.value?.Direction === 2)
    const connectorName = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorProviderName)
    const datasetName = computed(() => modelPipelineDetailsQueryV1.value?.DatasetName)
    const isActive = computed(() => modelPipelineDetailsQueryV1.value?.IsActive)
    const connectorId = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorId)
    const datasetId = computed(() => modelPipelineDetailsQueryV1.value?.DatasetId)
    const isDeleted = computed(() => modelPipelineDetailsQueryV1.value?.IsDeleted)
    const connectorProviderReadPageUrl = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorProviderReadPageUrl)
    const connectorProviderWritePageUrl = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorProviderWritePageUrl)
    const connectorOnlyInternalTriggers = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorOnlyInternalTriggers)
    const connectorInternalTriggers = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorInternalTriggers ?? [])
    const multipleDataStreams = computed(() => modelPipelineDetailsQueryV1.value?.MultipleDataStreams ?? false)
    const multipleDataStreamsError = computed(() => modelPipelineDetailsQueryV1.value?.MultipleDataStreamsError)
    const dataStream = computed(() => modelPipelineDetailsQueryV1.value?.DataStream)
    const selectedConnectorInternalTrigger = computed(() => connectorInternalTriggers.value.find(t => t.Name == internalConnectorTrigger.value))
    const availableLogLevels = computed(() => modelPipelineDetailsQueryV1.value?.AvailableLogLevels ?? [])
    const {
        invokeActivatePipelineCommandV1,
        succeed: succeedActivatePipelineCommandV1
    } = useActivatePipelineCommand(id, tid, userId)

    const {
        invokeDeactivatePipelineCommandV1,
        succeed: succeedDeactivatePipelineCommandV1
    } = useDeactivatePipelineCommand(id, tid, userId)

    const {
        invokeTriggerPipelineManuallyCommandV1,
        succeedTriggerPipelineManuallyCommandV1
    } = useTriggerPipelineManuallyCommand(id, tid, userId)

    const {
        invokeChangePipelineTimeTriggerRecurrencyCommandV1,
        succeedChangePipelineTimeTriggerRecurrencyCommandV1,
        timeTriggerRecurrency
    } = useChangePipelineTimeTriggerRecurrencyCommand(id, tid, userId)

    const {
        invokeChangePipelineTriggerOnRunCompletedCommandV1,
        succeedChangePipelineTriggerOnRunCompletedCommandV1,
        triggerOnRunCompleted
    } = useChangePipelineTriggerOnRunCompletedCommand(id, tid, userId)

    const {
        invokeChangePipelineInternalConnectorTriggerCommandV1,
        succeedChangePipelineInternalConnectorTriggerCommandV1,
        internalConnectorTrigger
    } = useChangePipelineInternalConnectorTriggerCommandV1(id, tid, userId)

    const {
        invokeResetPipelineRunsCommandV1,
        succeedResetPipelineRunsCommandV1
    } = useResetPipelineRunsCommand(id, tid, userId)

    const {
        invokeChangeApplyChangesModeCommandV1,
        succeedChangeApplyChangesModeCommandV1,
        applyChangesMode
    } = useChangeApplyChangesModeCommand(id, tid, userId)

    const {
        invokeChangeClearDatasetOnRunCommandV1,
        succeedChangeClearDatasetOnRunCommandV1,
        clearDatasetOnRun
    } = useChangeClearDatasetOnRunCommand(id, tid, userId)

    const {
        invokeDeletePipelineCommandV1,
        succeedDeletePipelineCommandV1
    } = useDeletePipelineCommand(id, tid, userId)

    const {
        invokeSetPipelineLogLevelCommandV1,
        succeedSetPipelineLogLevelCommandV1,
        logLevel
    } = useSetPipelineLogLevelCommand(id, tid, userId)

    const {
        invokePermanentDeletePipelineCommandV1,
        succeedPermanentDeletePipelineCommandV1
    } = usePermanentDeletePipelineCommand(id)

    watch(name, () => document.title = name.value)

    watch(
        [succeedTriggerPipelineManuallyCommandV1, succeedPermanentDeletePipelineCommandV1],
        (val) => val ? router.push(`/admin/integrations/pipelines/dashboard/${tid}`) : null)

    watch(modelPipelineDetailsQueryV1, () => {
        timeTriggerRecurrency.value = modelPipelineDetailsQueryV1.value?.TimeTriggerRecurrency
        triggerOnRunCompleted.value = modelPipelineDetailsQueryV1.value?.TriggerOnRunCompleted
        internalConnectorTrigger.value = modelPipelineDetailsQueryV1.value?.InternalConnectorTrigger
        applyChangesMode.value = modelPipelineDetailsQueryV1.value?.ApplyChangesMode
        logLevel.value = modelPipelineDetailsQueryV1.value?.LogLevel
        clearDatasetOnRun.value = modelPipelineDetailsQueryV1.value?.ClearDatasetOnRun
    })

    watch([
        succeedActivatePipelineCommandV1,
        succeedDeactivatePipelineCommandV1,
        succeedChangePipelineTimeTriggerRecurrencyCommandV1,
        succeedChangePipelineTriggerOnRunCompletedCommandV1,
        succeedChangePipelineInternalConnectorTriggerCommandV1,
        succeedResetPipelineRunsCommandV1,
        succeedDeletePipelineCommandV1,
        succeedChangeClearDatasetOnRunCommandV1
    ], () => runPipelineDetailsQueryV1())

    onMounted(() => {
        runCurrentUserQueryV1()
        runAllPipelinesQueryV1()
        runPipelineDetailsQueryV1()
    })

    function handleAbortPipelineRunsCommandV1() {
        if (confirm(`Do you really want to abort all runs of pipeline ${name.value}?`)) invokeResetPipelineRunsCommandV1()
    }

    function handleDeletePipelineCommandV1() {
        if (confirm(`Do you really want to delete pipeline ${name.value}?`)) invokeDeletePipelineCommandV1()
    }

    function handlePermanentDeletePipelineCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete pipeline ${name.value}?`)) invokePermanentDeletePipelineCommandV1()
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, [
            _createTextVNode(_toDisplayString(name.value) + " ", 1 /* TEXT */),
            (isReadDirection.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(Read)"))
              : _createCommentVNode("v-if", true),
            (isWriteDirection.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(Write)"))
              : _createCommentVNode("v-if", true)
          ]),
          (!isDeleted.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(invokeTriggerPipelineManuallyCommandV1) && _unref(invokeTriggerPipelineManuallyCommandV1)(...args))),
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[23] || (_cache[23] = [
                _createElementVNode("i", {
                  class: "fa fa-bolt",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" Run pipeline ", -1 /* CACHED */)
              ]))]))
            : _createCommentVNode("v-if", true),
          (!isDeleted.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: handleAbortPipelineRunsCommandV1,
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[24] || (_cache[24] = [
                _createElementVNode("i", {
                  class: "fa fa-ban",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" Abort runs ", -1 /* CACHED */)
              ]))]))
            : (_openBlock(), _createElementBlock("a", {
                key: 2,
                onClick: handlePermanentDeletePipelineCommandV1,
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[25] || (_cache[25] = [
                _createElementVNode("i", {
                  class: "fa fa-bolt",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" Delete permanently ", -1 /* CACHED */)
              ]))]))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[26] || (_cache[26] = _createElementVNode("button", {
              class: "btn btn-success dropdown-toggle",
              type: "button",
              "data-toggle": "dropdown",
              "aria-expanded": "false"
            }, " Share ", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: `/#/sharing/resource/PipelineTriggerDataShareResourceProvider/${_unref(id)}`
              }, "Trigger", 8 /* PROPS */, _hoisted_11)
            ])
          ])
        ])
      ])
    ]),
    _cache[65] || (_cache[65] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    (!isDeleted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/configure/connector/${_unref(tid)}/${_unref(id)}`
          }, "Configure connector", 8 /* PROPS */, _hoisted_13),
          _cache[52] || (_cache[52] = _createTextVNode(" ", -1 /* CACHED */)),
          _createElementVNode("span", null, "(" + _toDisplayString(connectorName.value || 'Not configured') + ")", 1 /* TEXT */),
          _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          (multipleDataStreams.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("a", {
                  href: `/#/admin/integrations/pipelines/configure/datastream/${_unref(tid)}/${_unref(id)}`
                }, "Configure data stream", 8 /* PROPS */, _hoisted_15),
                _createTextVNode(" (" + _toDisplayString(dataStream.value) + ") ", 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (multipleDataStreamsError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("strong", _hoisted_17, _toDisplayString(multipleDataStreamsError.value), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/configure/dataset/${_unref(tid)}/${_unref(id)}`
          }, "Configure dataset", 8 /* PROPS */, _hoisted_18),
          _cache[54] || (_cache[54] = _createTextVNode(" (", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/datasets/details/${datasetId.value}`,
            target: "_blank"
          }, _toDisplayString(datasetName.value || 'Not configured'), 9 /* TEXT, PROPS */, _hoisted_19),
          _cache[55] || (_cache[55] = _createTextVNode(")", -1 /* CACHED */)),
          _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/configure/properties/${_unref(tid)}/${_unref(id)}`
          }, "Configure properties", 8 /* PROPS */, _hoisted_20),
          _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/configure/mapping/${_unref(tid)}/${_unref(id)}`
          }, "Configure mappings", 8 /* PROPS */, _hoisted_21),
          _cache[58] || (_cache[58] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/configure/ids/${_unref(tid)}/${_unref(id)}`
          }, "Configure IDs", 8 /* PROPS */, _hoisted_22),
          _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/configure/filter/${_unref(tid)}/${_unref(id)}`
          }, "Configure filter", 8 /* PROPS */, _hoisted_23),
          _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/preview/${_unref(tid)}/${_unref(id)}`,
            class: "btn btn-primary mr-1",
            role: "button"
          }, "Preview", 8 /* PROPS */, _hoisted_24),
          (isReadDirection.value && connectorProviderReadPageUrl.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: `${connectorProviderReadPageUrl.value}${_unref(tid)}?pipelineId=${_unref(id)}&connectorId=${connectorId.value}`,
                class: "btn btn-primary mr-1",
                role: "button",
                target: "_blank"
              }, "Open", 8 /* PROPS */, _hoisted_25))
            : _createCommentVNode("v-if", true),
          (isWriteDirection.value && connectorProviderWritePageUrl.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: `${connectorProviderWritePageUrl.value}${_unref(tid)}?pipelineId=${_unref(id)}&connectorId=${connectorId.value}`,
                class: "btn btn-primary mr-1",
                role: "button",
                target: "_blank"
              }, "Open", 8 /* PROPS */, _hoisted_26))
            : _createCommentVNode("v-if", true),
          (!isActive.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(invokeActivatePipelineCommandV1) && _unref(invokeActivatePipelineCommandV1)(...args))),
                class: "btn btn-success mr-1"
              }, "Activate"))
            : (_openBlock(), _createElementBlock("button", {
                key: 5,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(invokeDeactivatePipelineCommandV1) && _unref(invokeDeactivatePipelineCommandV1)(...args))),
                class: "btn btn-warning mr-1"
              }, "Deactivate")),
          _createElementVNode("button", {
            onClick: handleDeletePipelineCommandV1,
            class: "btn btn-danger",
            disabled: isActive.value
          }, "Delete", 8 /* PROPS */, _hoisted_27),
          _cache[62] || (_cache[62] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[64] || (_cache[64] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          (!connectorOnlyInternalTriggers.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { for: "logLevel" }, "Log level:", -1 /* CACHED */)),
                  _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableLogLevels.value, (ll) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(logLevel) ? (logLevel).value = $event : null)),
                        class: "form-check-input",
                        type: "radio",
                        name: "logLevel",
                        id: `logLevel${ll.Value}`,
                        value: ll.Value
                      }, null, 8 /* PROPS */, _hoisted_31), [
                        [_vModelRadio, _unref(logLevel)]
                      ]),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `logLevel${ll.Value}`
                      }, _toDisplayString(ll.Name), 9 /* TEXT, PROPS */, _hoisted_32)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */)),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(invokeSetPipelineLogLevelCommandV1) && _unref(invokeSetPipelineLogLevelCommandV1)(...args))),
                    class: "btn btn-sm btn-secondary"
                  }, "Update")
                ]),
                (isReadDirection.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", { for: "clearDatasetOnRun" }, "Clear dataset on run:", -1 /* CACHED */)),
                      _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(clearDatasetOnRun) ? (clearDatasetOnRun).value = $event : null)),
                          class: "form-check-input",
                          type: "checkbox",
                          name: "clearDatasetOnRun",
                          id: "clearDatasetOnRun"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, _unref(clearDatasetOnRun)]
                        ]),
                        _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(clearDatasetOnRun) ? 'Yes' : 'No'), 1 /* TEXT */)
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(invokeChangeClearDatasetOnRunCommandV1) && _unref(invokeChangeClearDatasetOnRunCommandV1)(...args))),
                        class: "btn btn-sm btn-secondary"
                      }, "Update")
                    ]))
                  : _createCommentVNode("v-if", true),
                (isReadDirection.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { for: "applyChangesMode" }, "Apply changes mode:", -1 /* CACHED */)),
                      _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_37, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(applyChangesMode) ? (applyChangesMode).value = $event : null)),
                          class: "form-check-input",
                          type: "radio",
                          name: "applyChangesMode",
                          id: "applyChangesModeAllAtOnce",
                          value: 1
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelRadio, _unref(applyChangesMode)]
                        ]),
                        _cache[31] || (_cache[31] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "applyChangesModeAllAtOnce"
                        }, "All at once", -1 /* CACHED */))
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(applyChangesMode) ? (applyChangesMode).value = $event : null)),
                          class: "form-check-input",
                          type: "radio",
                          name: "applyChangesMode",
                          id: "applyChangesModeOneByOne",
                          value: 2
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelRadio, _unref(applyChangesMode)]
                        ]),
                        _cache[32] || (_cache[32] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "applyChangesModeOneByOne"
                        }, "One by one", -1 /* CACHED */))
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(applyChangesMode) ? (applyChangesMode).value = $event : null)),
                          class: "form-check-input",
                          type: "radio",
                          name: "applyChangesMode",
                          id: "applyChangesModeGroupByItem",
                          value: 3
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelRadio, _unref(applyChangesMode)]
                        ]),
                        _cache[33] || (_cache[33] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "applyChangesModeGroupByItem"
                        }, "Group by item", -1 /* CACHED */))
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(invokeChangeApplyChangesModeCommandV1) && _unref(invokeChangeApplyChangesModeCommandV1)(...args))),
                        class: "btn btn-sm btn-secondary"
                      }, "Update")
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_40, [
                  _cache[43] || (_cache[43] = _createElementVNode("label", { for: "timeTriggerRecurrency" }, "Time trigger:", -1 /* CACHED */)),
                  _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(timeTriggerRecurrency) ? (timeTriggerRecurrency).value = $event : null)),
                      class: "form-check-input",
                      type: "radio",
                      name: "timeTriggerRecurrency",
                      id: "timeTriggerRecurrencyNone",
                      value: null
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _unref(timeTriggerRecurrency)]
                    ]),
                    _cache[36] || (_cache[36] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "timeTriggerRecurrencyNone"
                    }, "None", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(timeTriggerRecurrency) ? (timeTriggerRecurrency).value = $event : null)),
                      class: "form-check-input",
                      type: "radio",
                      name: "timeTriggerRecurrency",
                      id: "timeTriggerRecurrency10m",
                      value: "00:15:00"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _unref(timeTriggerRecurrency)]
                    ]),
                    _cache[37] || (_cache[37] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "timeTriggerRecurrency10m"
                    }, "Every 15 minutes", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(timeTriggerRecurrency) ? (timeTriggerRecurrency).value = $event : null)),
                      class: "form-check-input",
                      type: "radio",
                      name: "timeTriggerRecurrency",
                      id: "timeTriggerRecurrency10m",
                      value: "00:30:00"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _unref(timeTriggerRecurrency)]
                    ]),
                    _cache[38] || (_cache[38] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "timeTriggerRecurrency10m"
                    }, "Every 30 minutes", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(timeTriggerRecurrency) ? (timeTriggerRecurrency).value = $event : null)),
                      class: "form-check-input",
                      type: "radio",
                      name: "timeTriggerRecurrency",
                      id: "timeTriggerRecurrency1h",
                      value: "01:00:00"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _unref(timeTriggerRecurrency)]
                    ]),
                    _cache[39] || (_cache[39] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "timeTriggerRecurrency1h"
                    }, "Hourly", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(timeTriggerRecurrency) ? (timeTriggerRecurrency).value = $event : null)),
                      class: "form-check-input",
                      type: "radio",
                      name: "timeTriggerRecurrency",
                      id: "timeTriggerRecurrency1d",
                      value: "1.00:00:00"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _unref(timeTriggerRecurrency)]
                    ]),
                    _cache[40] || (_cache[40] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "timeTriggerRecurrency1d"
                    }, "Daily", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(timeTriggerRecurrency) ? (timeTriggerRecurrency).value = $event : null)),
                      class: "form-check-input",
                      type: "radio",
                      name: "timeTriggerRecurrency",
                      id: "timeTriggerRecurrency7d",
                      value: "7.00:00:00"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _unref(timeTriggerRecurrency)]
                    ]),
                    _cache[41] || (_cache[41] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "timeTriggerRecurrency7d"
                    }, "Weekly", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(timeTriggerRecurrency) ? (timeTriggerRecurrency).value = $event : null)),
                      class: "form-check-input",
                      type: "radio",
                      name: "timeTriggerRecurrency",
                      id: "timeTriggerRecurrency30d",
                      value: "30.00:00:00"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _unref(timeTriggerRecurrency)]
                    ]),
                    _cache[42] || (_cache[42] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "timeTriggerRecurrency30d"
                    }, "Every 30 days", -1 /* CACHED */))
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_unref(invokeChangePipelineTimeTriggerRecurrencyCommandV1) && _unref(invokeChangePipelineTimeTriggerRecurrencyCommandV1)(...args))),
                    class: "btn btn-sm btn-secondary"
                  }, "Update")
                ]),
                (!connectorOnlyInternalTriggers.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _cache[46] || (_cache[46] = _createElementVNode("label", { for: "triggerOnRunCompleted" }, "Pipeline completed trigger:", -1 /* CACHED */)),
                      _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(triggerOnRunCompleted) ? (triggerOnRunCompleted).value = $event : null)),
                        class: "form-control",
                        id: "triggerOnRunCompleted"
                      }, [
                        _cache[45] || (_cache[45] = _createElementVNode("option", { value: null }, "None", -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherPipelines.value, (p) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: p.PipelineId,
                            key: p.PipelineId
                          }, _toDisplayString(p.Name), 9 /* TEXT, PROPS */, _hoisted_49))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, _unref(triggerOnRunCompleted)]
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_unref(invokeChangePipelineTriggerOnRunCompletedCommandV1) && _unref(invokeChangePipelineTriggerOnRunCompletedCommandV1)(...args))),
                        class: "btn btn-sm btn-secondary"
                      }, "Update")
                    ]))
                  : _createCommentVNode("v-if", true),
                (connectorInternalTriggers.value.length>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _cache[49] || (_cache[49] = _createElementVNode("label", { for: "internalConnectorTrigger" }, "Pipeline connector trigger:", -1 /* CACHED */)),
                      _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(internalConnectorTrigger) ? (internalConnectorTrigger).value = $event : null)),
                        class: "form-control",
                        id: "internalConnectorTrigger"
                      }, [
                        _cache[48] || (_cache[48] = _createElementVNode("option", { value: null }, "None", -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectorInternalTriggers.value, (t) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: t.Name,
                            key: t.Name
                          }, _toDisplayString(t.Title), 9 /* TEXT, PROPS */, _hoisted_51))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, _unref(internalConnectorTrigger)]
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_unref(invokeChangePipelineInternalConnectorTriggerCommandV1) && _unref(invokeChangePipelineInternalConnectorTriggerCommandV1)(...args))),
                        class: "btn btn-sm btn-secondary"
                      }, "Update"),
                      (selectedConnectorInternalTrigger.value?.PageUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: `${selectedConnectorInternalTrigger.value?.PageUrl}/?pipelineId=${_unref(id)}&connectorId=${connectorId.value}`,
                            target: "_blank"
                          }, "Open", 8 /* PROPS */, _hoisted_52))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_53, [...(_cache[51] || (_cache[51] = [
                _createElementVNode("h4", null, "Pipeline was deleted", -1 /* CACHED */)
              ]))]))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})